import { render, staticRenderFns } from "./batchProjectModal.vue?vue&type=template&id=676e57cd&scoped=true"
import script from "./batchProjectModal.vue?vue&type=script&lang=js"
export * from "./batchProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e57cd",
  null
  
)

export default component.exports